import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { useVideoFrames } from "hooks/use-video-frames/index.js";
import { Progress } from "antd";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { useVideoFramesV2 } from "hooks/use-video-frames-v2/index.js";

export function VideoWrapper({
  containerHeight,
  videoSrc,
  setIsReadyToPlay,
  timestamps,
  currentFrame,
  videoHeight,
  frameRate,
  activeExtraction,
  extractionProgress,
  isM2cAnalytics,
  frames,
}: any) {
  const videoRef = useRef<HTMLVideoElement>(null);

  let VIDEO_HEIGHT = window.screen.availHeight;

  function getVideoRatio(height: any) {
    const finalWidth = (height * 9) / 16;
    return finalWidth + "px";
  }

  function getWidthForVideo() {
    return getVideoRatio(containerHeight);
  }

  function getHeightForVideo() {
    if (videoHeight) {
      return videoHeight;
    }
    return `${containerHeight}px`;
  }

  const stylesForVideo: any = {
    height: getHeightForVideo(),
  };
  const stylesForImage: any = {
    height: getHeightForVideo(),
    objectFit: "contain",
  };

  useEffect(() => {
    const video: any = videoRef.current;

    if (timestamps) {
      const displayFrames = () => {
        const timestamp = timestamps[currentFrame];
        if (
          typeof timestamp === "number" &&
          isFinite(timestamp) &&
          videoRef.current
        ) {
          video.currentTime = timestamp;
        }
      };

      displayFrames();
    }
  }, [currentFrame, videoSrc]);

  return (
    <div
      className={styles.videoContainer}
      style={{
        width: isM2cAnalytics ? "100%" : getWidthForVideo(),
      }}
    >
      {activeExtraction && frames?.length > 0 && extractionProgress === 100 ? (
        <img
          src={frames[currentFrame]}
          alt={currentFrame}
          style={stylesForImage}
          className={styles.video}
        />
      ) : (
        <>
          <video
            src={`${videoSrc}`}
            ref={videoRef as any}
            style={stylesForVideo}
            className={styles.video}
            onCanPlayThrough={() => {
              setIsReadyToPlay(true);
            }}
            preload={"auto"}
          />
          <ConditionalRenderer
            condition={
              activeExtraction &&
              extractionProgress > 0 &&
              extractionProgress < 100
            }
          >
            <div
              style={{
                position: "absolute",
                color: "white",
                top: "50px",
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Progress
                type="dashboard"
                percent={extractionProgress}
                size="small"
                format={(percent) => (
                  <h4 style={{ color: "#006ab3" }}>{extractionProgress}%</h4>
                )}
              />
              {/* {extractionProgress}% */}
            </div>
          </ConditionalRenderer>
        </>
      )}
    </div>
  );
}
